import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { MiBuildLogo } from "@miplatform/assets";
import { Box } from "@mui/material";

const useStyles = makeStyles()(() => ({
  rootContainer: {
    cursor: "pointer",
  },
}));

export function HeaderLogo() {
  const { classes } = useStyles();

  return (
    <Box className={classes.rootContainer} component={Link} to="/">
      <img src={MiBuildLogo} alt="Logo" />
    </Box>
  );
}
